import React from "react";
import { Box, Typography, Button, Container, Avatar } from "@mui/material";

function Hero() {
  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        bgcolor: "background.default",
        backgroundImage:
          "linear-gradient(135deg, rgba(230,219,172,0.3), rgba(82,178,191,0.25))",
      }}
    >
      <Container sx={{ textAlign: "center" }}>
        {/* Clickable Profile Picture */}
        <a
          href="https://www.linkedin.com/in/mohankrishnamadanapu29546b1b3/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <Avatar
            alt="Madanapu Mohan Krishna"
            src="/pic.jpeg"   // place your image in public folder
            sx={{
              width: 150,
              height: 150,
              margin: "0 auto 20px auto",
              boxShadow: 3,
              transition: "transform 0.3s ease",
              "&:hover": { transform: "scale(1.1)" },
            }}
          />
        </a>

        <Typography variant="h2">Madanapu Mohan Krishna</Typography>
        <Typography variant="h5" sx={{ mt: 2, color: "text.secondary" }}>
          Full‑Stack Developer • Java • Spring Boot • React • REST APIs
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Button
            variant="contained"
            color="primary"
            href="#projects"
            sx={{ mr: 2 }}
          >
            View My Work
          </Button>
          <Button
            variant="outlined"
            color="primary"
            href="#resume"
            sx={{ borderColor: "#52B2BF" }}
          >
            Download Resume
          </Button>
        </Box>
      </Container>
    </Box>
  );
}

export default Hero;
